import styled from 'styled-components';

export const Container = styled.div({
  width: '100%',
  marginTop: '24rem',
  display: 'flex',
  justifyContent: 'flex-start',
});

export const Image = styled.img({
  width: '100%',
  height: 'auto',
  // Cap by the remaining viewport height so the whole image fits without
  // scrolling. ~440rem accounts for the header (139rem), main padding
  // (30rem top / 100rem bottom) and the ZIP search block above it.
  // 1rem === 1px in this project (see Layout.styles.ts).
  maxWidth: '1200rem',
  maxHeight: 'calc(100vh - 440rem)',
  display: 'block',
  borderRadius: '8rem',
});
